import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  size?: "lg" | "xl";
  className?: string;
};
export function CtaButton({
  label,
  id,
  size = "lg",
  className = ""
}: CtaButtonProps) {
  const sizing = size === "xl" ? "py-5 sm:py-6 text-xl sm:text-2xl" : "py-[18px] sm:py-5 text-[17px] sm:text-xl";
  return <a id={id} href={CHECKOUT_URL} className={`group inline-flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 text-center font-display font-extrabold uppercase leading-tight tracking-wide text-white shadow-cta transition-[background-color,transform] duration-150 ease-out hover:bg-ctaDark active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:w-auto sm:min-w-[440px] sm:px-10 ${sizing} ${className}`} data-id="element-29" data-mp="qjilxx9mba4o">
      <span data-id="element-30" data-mp="15a9dr5b7m97s">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="15b18kdwzg2x0" />
    </a>;
}